import { render, staticRenderFns } from "./ModalMetricsBySkillPacks.vue?vue&type=template&id=8631d070&scoped=true&"
import script from "./ModalMetricsBySkillPacks.vue?vue&type=script&lang=js&"
export * from "./ModalMetricsBySkillPacks.vue?vue&type=script&lang=js&"
import style0 from "./ModalMetricsBySkillPacks.vue?vue&type=style&index=0&id=8631d070&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8631d070",
  null
  
)

export default component.exports